const WordFileIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 42 16" aria-hidden="true" className={className}>
    <text
      x="21"
      y="8"
      fill="currentColor"
      fontSize="8.5"
      fontWeight="700"
      fontFamily="Arial, sans-serif"
      textAnchor="middle"
      dominantBaseline="middle"
    >
      DOCX
    </text>
  </svg>
)

export default WordFileIcon
